import { sendToMixpanel } from '../mixpanel';

export default (filterText: string): void =>
  sendToMixpanel('Filter FAA Search Results', {
    filterText,
  });
